/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetZeusOrganizations200ResponseOrganizationsInner
 */
export interface GetZeusOrganizations200ResponseOrganizationsInner {
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizations200ResponseOrganizationsInner
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizations200ResponseOrganizationsInner
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetZeusOrganizations200ResponseOrganizationsInner
     */
    'connectedMoneytree': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetZeusOrganizations200ResponseOrganizationsInner
     */
    'brandType'?: GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum;
}

export const GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum = {
    upsider: 'UPSIDER',
    presidentCard: 'PRESIDENT_CARD'
} as const;

export type GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum = typeof GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum[keyof typeof GetZeusOrganizations200ResponseOrganizationsInnerBrandTypeEnum];


